



































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {},
})
export default class Terms extends Vue {

    mounted(){
        if(this.$route.params.locale === 'en'){
            this.$router.push({
                params: {locale: 'ko'}
            })
        }
    }
}
